export default {
  path: 'employee',
  name: '职工考勤',
  icon: 'WorkingHoursFilled',
  accessKey: '/employee/list',
  routes: [
    {
      path: 'list',
      component: '@/pages/employee/list',
      name: '职工管理',
      accessKey: '/employee/list',
    },
    {
      path: 'create',
      component: '@/pages/employee/list/create',
      name: '新增人员',
      hideInMenu: true,
      accessKey: '/employee/list',
      selectedKey: '/employee/list',
    },
    {
      path: 'edit',
      component: '@/pages/employee/list/create',
      name: '编辑人员',
      hideInMenu: true,
      accessKey: '/employee/list',
      selectedKey: '/employee/list',
    },
    {
      path: 'detail',
      component: '@/pages/employee/list/detail',
      name: '人员详情',
      hideInMenu: true,
      accessKey: '/employee/list',
      selectedKey: '/employee/list',
    },
    {
      path: 'plan',
      component: '@/pages/employee/plan',
      name: '考勤排班',
      accessKey: '/employee/plan',
    },
    {
      path: 'plan/create',
      component: '@/pages/employee/plan/create',
      name: '新增考勤排班',
      hideInMenu: true,
      accessKey: '/employee/plan',
      selectedKey: '/employee/plan',
    },
    {
      path: 'plan/edit',
      component: '@/pages/employee/plan/create',
      name: '编辑考勤排班',
      hideInMenu: true,
      accessKey: '/employee/plan',
      selectedKey: '/employee/plan',
    },
    {
      path: 'scheduling',
      component: '@/pages/employee/scheduling',
      name: '班次管理',
      accessKey: '/employee/scheduling',
    },
    {
      path: 'holiday',
      component: '@/pages/employee/holiday',
      name: '节假日管理',
      accessKey: '/employee/holiday',
    },
    {
      path: 'day',
      component: '@/pages/employee/day',
      name: '每日考勤',
      accessKey: '/employee/day',
    },
    {
      path: 'day/record',
      component: '@/pages/employee/day/record',
      name: '补卡记录',
      hideInMenu: true,
      accessKey: '/employee/day',
      selectedKey: '/employee/day',
    },
    {
      path: 'month',
      component: '@/pages/employee/month',
      name: '月度汇总',
      accessKey: '/employee/month',
    },
    {
      path: 'month/detail',
      component: '@/pages/employee/month/detail',
      name: '详情',
      hideInMenu: true,
      accessKey: '/employee/month',
      selectedKey: '/employee/month',
    },
    {
      path: 'record',
      component: '@/pages/employee/record',
      name: '打卡记录',
      accessKey: '/employee/record',
    },
  ],
};
